import { Card } from 'components/Card';
import React, { FC } from 'react';
import cx from 'clsx';
import styles from './PerkCard.module.scss';
import { Perk } from 'hooks/context/Perks.model';
import { PERK_CARD } from './PerkCard.const';
import { PerkImage } from './PerkImage';
import { PerkProgress } from './PerkProgress';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';

type PerkCardProps = React.HTMLAttributes<HTMLElement> & {
  perk: Perk;
  showPerkProgress?: boolean;
  applied?: boolean;
  disabled?: boolean;
  isClickable?: boolean;
  scheduledPerkContent?: React.ReactNode;
}

export const PerkCard : FC<PerkCardProps> = ({ className, perk, showPerkProgress, applied, disabled, isClickable, scheduledPerkContent, ...props }) => {
  const { t } = useTranslation();
  const { iconUrl, backgroundIconUrl, subtitle, title, perkType, earned, required, available, uuid } = perk;

  return (
    <Card {...props}
      tabIndex={0}
      className={cx(styles.perk, { [styles.disabled]: disabled }, className)}
      data-testid={PERK_CARD.root}
      linkTo={uuid}>
      {applied ?
        <Icon name="greenCircleCheck" className={styles.appliedIcon} data-testid={PERK_CARD.appliedIcon} /> :
        <PerkImage iconUrl={iconUrl} backgroundIconUrl={backgroundIconUrl} disabled={disabled} data-testid={PERK_CARD.image} />
      }
      <div className={styles.content}>
        <p data-testid={PERK_CARD.heading}>{title}</p>
        {applied && <p className={cx(styles.appliedText, styles.greenText)}>{t('perks.applied')}</p> }
        {subtitle && <p className={cx(styles.subtitle)} data-testid={PERK_CARD.subtitle}>{subtitle}</p>}
        {scheduledPerkContent && <p className={cx(styles.subtitle)} data-testid={PERK_CARD.scheduledPerk}>{scheduledPerkContent}</p>}
        {showPerkProgress && <PerkProgress className={styles.progressBar} perkType={perkType} earned={earned} required={required} complete={available} /> }
      </div>
      {isClickable && <p className={cx(styles.cta, {
        [styles.greenText]: applied || !disabled,
      })}>{t(applied ? 'perks.remove' : 'perks.redeem')}</p>}
    </Card>
  );
};
